import React from 'react';
import { MapPin, Landmark } from 'lucide-react';
import CityPicker from './CityPicker';

// Ajustes de un negocio de pedidos que vende desde su minisitio: ciudades donde reparte y los datos para pagar por transferencia.
// Se guardan con «Guardar Configuración Base». Las columnas las crea la migración 20261007d_public_orders_cities.sql.
export default function OrderSiteSettings({ business, onChange }) {
  const inputClass = 'w-full bg-seryi-bg-dark border border-seryi-bg-light rounded-xl px-4 py-2.5 text-xs text-seryi-heading focus:outline-none focus:border-seryi-green';

  return (
    <div className="space-y-4 bg-seryi-bg-dark/40 border border-seryi-bg-light rounded-2xl p-4" aria-label="Pedidos desde el minisitio">
      <p className="text-[10px] uppercase tracking-wider font-bold text-seryi-text">Pedidos desde el minisitio</p>

      <div className="space-y-1">
        <label className="text-[10px] uppercase tracking-wider font-bold text-seryi-text flex items-center gap-1.5"><MapPin size={12} /> Ciudades de entrega</label>
        <CityPicker value={business.delivery_cities} onChange={(list) => onChange('delivery_cities', list)} />
        <p className="text-[10px] text-seryi-text/80">Escógelas de la lista (ciudades y municipios de Colombia) para que el nombre quede siempre igual. El cliente elige su ciudad al pedir y cada domiciliario (en Equipo) solo ve los pedidos de la suya.</p>
      </div>

      <div className="space-y-1">
        <label htmlFor="payment-info" className="text-[10px] uppercase tracking-wider font-bold text-seryi-text flex items-center gap-1.5"><Landmark size={12} /> Datos para pagar por transferencia</label>
        <textarea
          id="payment-info" rows={4} className={`${inputClass} font-sans leading-relaxed`}
          placeholder={'Bancolombia ahorros 123-456789-00\nA nombre de AguaPura SAS - NIT 900.000.000\nNequi 300 123 4567'}
          value={business.payment_info || ''}
          onChange={(e) => onChange('payment_info', e.target.value)}
        />
        <p className="text-[10px] text-seryi-text/80">Se le muestra al cliente cuando elige «Transferencia» en el minisitio y en su confirmación. Si lo dejas vacío, solo verá que el negocio le enviará los datos.</p>
      </div>

      <label className="flex items-start gap-2 text-xs text-seryi-heading cursor-pointer">
        <input
          type="checkbox" className="mt-0.5" checked={business.payment_reminders !== false}
          onChange={(e) => onChange('payment_reminders', e.target.checked)}
        />
        <span>
          Recordar el pago por WhatsApp a quien eligió transferencia y no ha pagado
          <span className="block text-[10px] text-seryi-text/80">Un recordatorio a los 30 minutos y otro 3 horas después (máximo 2, de 8:00 a 20:00), con el número del pedido y estos datos. Lo envía el flujo «Pedidos: recordatorio de pago» de n8n. Cuando registras el pago del pedido, deja de recordarle.</span>
        </span>
      </label>
    </div>
  );
}
